"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const GlobalData_1 = require("../Utility/GlobalData");
const DependencyInjector_1 = require("../Utility/DependencyInjector");
const Config_1 = require("../Config/Config");
const FetchProxy_1 = require("../Utility/FetchProxy");
class Device {
    async initialize() {
        if (GlobalData_1.currentUser !== undefined) {
            await this.updateAlive();
        }
    }
    async updateAlive() {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/device/alive`, {
                method: 'PUT'
            }).auth().fetch();
        }
        catch (err) {
            throw new Error(`Update device alive fail: status ${err.message}`);
        }
    }
    async create(firebaseToken) {
        try {
            const browser = (0, DependencyInjector_1.detectBrowser)();
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/device/create`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    deviceId: GlobalData_1.currentUser.data.token,
                    deviceType: 3,
                    serialNo: browser.name,
                    osVersion: browser.version,
                    firebaseToken: firebaseToken
                })
            }).auth().fetch();
        }
        catch (err) {
            throw new Error(`Create device fail: status ${err.message}`);
        }
    }
    async delete() {
        try {
            await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/device/delete`, {
                method: 'DELETE'
            }).auth().fetch();
        }
        catch (err) {
            throw new Error(`Delete device fail: status ${err.message}`);
        }
    }
}
exports.default = Device;
//# sourceMappingURL=Device.js.map